'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { TBitrixPage, TPage } from '@/shared/types/deprecated-types'

type Props = {
	page: TBitrixPage
	breadcrumbs: TPage[]
}

const PagesSlugPageContent = ({ page }: { page: TBitrixPage }) => {
	const { DETAIL_TEXT } = page

	return (
		<>
			<section dangerouslySetInnerHTML={createMarkup(DETAIL_TEXT)} />
		</>
	)
}

export function PagesSlugClient({ page, breadcrumbs }: Props) {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<PagesSlugPageContent page={page} />
		</>
	)
}
